<template>
  <aha-modal-group
    @hide="hide()"
    :hideSecondary="isShowShareACopyList"
    modalPosition="top"
    :bodyPadding="false"
    :headerPadding="false"
    headerClasses="pl-4 pr-3 ml-1"
  >
    <template #header>
      <aha-svg
        v-if="isShowShareACopyList"
        size="lg"
        name="arrow-tail"
        view-box="0 0 18 19"
        @click="handleClickBack()"
        class="align-middle mr-2 cursor-pointer flex-shrink-0"
      />
      <aha-icon-container
        v-else
        class="my-3 mr-2 font-bold truncate cursor-pointer"
        size="md"
        icon-class="bg-secondary-40 text-base-0"
      >
        <aha-icon
          name="phone"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        />
      </aha-icon-container>
      <span class="inline-block align-middle text-sm">{{ shareModalTitle }}</span>
    </template>
    <template #main>
      <InviteParticipants
        v-if="!isShowShareACopyList"
        :isShowShareACopyList="isShowShareACopyList"
        :presentation="presentation"
        hasPadding
        class="pb-5"
      />
      <hr class="text-base-30" v-if="!isShowShareACopyList" />
      <div @click="clickedPublishTemplateTab">
        <aha-accordion class="share-accordion">
          <aha-accordion-item v-if="!isShowShareACopyList && showPublicCommunity">
            <template slot="title">
              <h5 class="text-secondary-100 flex items-center">
                <aha-icon-container
                  class="mr-2 font-bold truncate cursor-pointer"
                  size="md"
                  icon-class="bg-secondary-40 text-base-0"
                >
                  <aha-icon
                    name="inspiration"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  />
                </aha-icon-container>
                Publish to Template Library
              </h5>
            </template>
            <template slot="content">
              <ShareToCommunity
                from="presentation-list"
                :presentation="presentation"
                @handleShowSendACopyDialog="isShowShareACopyList = true"
              />
            </template>
          </aha-accordion-item>

          <aha-accordion-item
            :has-bottom-border="false"
            :class="{'showing-share-a-copy-list': isShowShareACopyList}"
          >
            <template slot="title">
              <h5 class="text-secondary-100 flex items-center">
                <aha-icon-container
                  class="mr-2 font-bold truncate cursor-pointer"
                  size="md"
                  icon-class="bg-secondary-40 text-base-0"
                >
                  <aha-icon
                    name="duplicated"
                    width="14"
                    height="14"
                    viewBox="0 0 18 18"
                  />
                </aha-icon-container>
                Share a copy
              </h5>
            </template>
            <template slot="content">
              <ShareACopy
                :hide-title="true"
                v-if="!isShowShareACopyList"
                :presentation="presentation"
                @handleShowSendACopyDialog="showSendACopyDialog()"
              />
              <SendACopyList
                v-else
                :presentation="presentation"
              />
            </template>
          </aha-accordion-item>
        </aha-accordion>
      </div>
    </template>
  </aha-modal-group>
</template>

<script>
import { mapState } from 'vuex'

import InviteParticipants from '@/components-v2/presentation-editor/editor-header/InviteParticipants.vue'
import SendACopyList from '@/components-v2/modals/RecipientsList.vue'
import ShareACopy from '@/components-v2/presentation-editor/collaboration/ShareACopy.vue'
import ShareToCommunity from '@/components-v2/presentation-editor/editor-header/ShareToCommunity.vue'
import Config from '@/config'
import constants from '@/constant'
import Utils from '@/util'
import gaCategories from '@/constant/gaCategories'

export default {
  components: {
    InviteParticipants,
    SendACopyList,
    ShareACopy,
    ShareToCommunity,
  },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      shareModalTitle: 'Share to participants',
      isShowShareACopyList: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    showPublicCommunity() {
      if (!this.currentUser.email || Config.region === constants.euRegion
        || this.currentUser.isDisablePublicTemplate) {
        return false
      }
      return true
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
    handleClickBack() {
      this.isShowShareACopyList = false
      this.shareModalTitle = 'Share to participants'
    },
    showSendACopyDialog() {
      this.shareModalTitle = 'Send a copy to team members'
      this.isShowShareACopyList = true
    },
    clickedPublishTemplateTab() {
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_LIST,
        'Switch to Share Community tab',
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.showing-share-a-copy-list {
  & ::v-deep .accordion-item-title {
    @apply hidden;
  }
}
.share-accordion {
  & ::v-deep {
    .accordion-item--expanded {
      .share-accordion__badge {
        display: none;
      }
    }
  }
}
</style>
